<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="storageItems"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"
    :showExpand="true"
    :hasTopMenu="false"
    :hasTableTitle="false"
    :hasDefaultPageTitle="false"
    :customExpandIcon="true"
    @row-clicked="handleRowClicked"
    class="row-pointer"
    :containSearchBar="false"
  >
   

    <template v-slot:expand="{ item, headers }">
      <td :colspan="headers.length" :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row': '')">
        <ExitMovementItemLotIndex
          :hasTopMenu="false"
          :loading="false"
          :storageItemLots.sync="item.exitMovementItemLotsAttributes"          
          class="mt-6"                   
          :readOnly="readOnly"
        />
      </td>
     
    </template>

    <template v-slot:expandColumn="{ item, isExpanded, expand }">
      <v-btn text color="primary" v-if="!isExpanded">Ver Lotes</v-btn>
      <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon>Lotes</v-btn>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import ExitMovementItemLotIndex from "./exit_movement_item_lot_index.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: [],
      maskFields: [
        // { field: 'averageUnitPrice', mask: 'currency_10d' }, 
        { field: 'quantity', mask: 'number'},
        // { field: 'availableQuantity', mask: 'number'}, 
        // { field: 'movementItemAvailableQuantity', mask: 'number'},
        // { field: 'totalPrice',mask: 'currency'},
        // { field: 'availableTotalPrice', mask: 'currency' }
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    ExitMovementItemLotIndex: ExitMovementItemLotIndex,    
  },
  props: {
    storageItems: {
      type: Array,
      default: () => [],
    },
    storageItemsTotalPrice: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    hasLots: {
      type: Boolean,
      default: false,
    },
    enabledLots: {
      type: Boolean,
      default: false,
    },    
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Item de Estoque"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de Estoque"
    },
  },
  created() {
  },
  computed: {
    tableHeaders() {
      var indexTable = [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        // { text: "R$ Médio", align: "left", sortable: true, value: "averageUnitPrice" },
        { text: "Qtd.", align: "left", sortable: true, value: "quantity" }, 
          // { text: "Qtd. Disponível Mov. It.", align: "left", sortable: true, value: "movementItemAvailableQuantity" },
          // ... this.objectType == "StockItem" ? [{ text: "Qtd. Disponível", align: "left", sortable: true, value: "availableQuantity" }] : [{ text: "Qtd.", align: "left", sortable: true, value: "purchaseQuantity" }],
        { text: "Und.", align: "left", sortable: true, value: "packaging.basicUnitName" },
        // { text: "R$ Total", align: "left", sortable: true, value: "availableTotalPrice" },
      ];
      // console.log("enabled", this.enabledLots);
        // if (this.exitMovementItemLotsAttributes.length > 1){
        indexTable.push({ text: "Lotes", value: "data-table-expand", sortable: false },);
        // }
        return indexTable;
    }
  },
  methods: {
    entryUpdated: function(editedStorageItem){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    entryCreated: function(newStorageItem){
      this.storageItems.push(newStorageItem);
      this.$refs.baseIndex.showConfirmationCreateMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    entryDeleted: function(deletedStorageItem){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    handleRowClicked: function(rowArguments) {
      // console.log("row click", rowArguments);
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    }
  }
};
</script>

<style lang="css" scoped>
  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }
</style>
